import { SearchOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import React from 'react'
import { CustomeButton } from '../../../StyledComponents/Common'
import { IconImg } from '../../../StyledComponents/Header'

function AddButton(props) {
    let icon_img = require('../../../assets/admin/images/addplus_icon.png')
    if(props.icon_type === 'edit') {
        icon_img = require('../../../assets/admin/images/editicon.png')
    }else if (props.icon_type === 'archive'){
      icon_img = require('../../../assets/admin/images/archive-add.png')
    }else if (props.icon_type === 'download'){
      icon_img = require('../../../assets/admin/images/download_icon.png')
    }
  return (
    <div className="viewRateBtn">
      {props.is_icon === false?<CustomeButton onClick={()=> props.handleClick ? props.handleClick() : null} size='large' loading={props.loading}>{props.title}</CustomeButton> :
       <CustomeButton className="btn btn_54" onClick={()=> props.handleClick? props.handleClick() : null} size='large' icon={<IconImg src={icon_img} />} loading={props.loading}>{props.title}</CustomeButton> }
    </div>
  )
}

export default AddButton
